import React from 'react';
import ReactDom from 'react-dom';
import App from './App';

import styles from './assets/styles/styles.less';

ReactDom.render(
	<App />,
	document.getElementById('app')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/